const expandButtons = document.querySelectorAll(
	'.block-card-reviews__expand-button'
);

if (expandButtons.length > 0) {
	expandButtons.forEach((expandButton) => {
		expandButton.addEventListener('click', (e) => {
			e.preventDefault();

			e.currentTarget.parentElement.classList.toggle('expanded');
		});
	});
}
